import { render, staticRenderFns } from "./Explanation8.vue?vue&type=template&id=7a731683&scoped=true&lang=pug&"
import script from "./Explanation8.vue?vue&type=script&lang=ts&"
export * from "./Explanation8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a731683",
  null
  
)

export default component.exports